import { Entity, FeedData, Matrix } from './Feed.types';

const getPriority = () => {
    let flag = 1;

    return function () {
        if (flag) {
            flag = 0;

            return Entity.Prompt;
        }
        flag = 1;

        return Entity.Challenge;
    };
};

const getMatrix = (columns: number, priority: () => string, hasCollections: boolean): Matrix => {
    const matrix: Matrix = {
        '0': {
            prompts: columns,
            weight: columns === 2 ? columns * 2 : columns,
        },
        '1': {
            prompts: columns - 2,
            challenge: 1,
            priority: priority(),
            weight: columns,
        },
        '2': {
            prompts: columns,
            weight: columns === 2 ? columns * 2 : columns,
        },
        '3': {
            collections: hasCollections ? 1 : 0,
            courses: hasCollections ? 0 : 1,
            weight: columns,
        },
    };

    return matrix;
};

export const getOrderedFeed = (feedData: FeedData, columns: number) => {
    const { collections, prompts, challenges, courses } = feedData;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const feed: any[] = [];
    const weights = {
        promt: 1,
        challenge: 2,
        collection: columns,
        course: columns,
    };
    let collectionIndex = 0;
    let promtIndex = 0;
    let challengeIndex = 0;
    let courseIndex = 0;

    const hasPromptsLeft = () => {
        return promtIndex < prompts.length;
    };

    const canAddChallenge = () => {
        return challengeIndex < challenges.length;
    };

    const canAddCollection = () => {
        return collectionIndex < collections.length;
    };

    const canAddCourse = () => {
        return courseIndex < courses.length;
    };

    const addPrompts = (count: number = 1): number => {
        let added = 0;
        for (let i = 0; i < count && hasPromptsLeft(); i++) {
            feed.push(prompts[promtIndex]);
            promtIndex++;
            added++;
        }

        return added;
    };

    const addChallenge = (): number => {
        if (!canAddChallenge()) {
            return 0;
        }

        feed.push(challenges[challengeIndex]);
        challengeIndex++;

        return weights.challenge;
    };

    const addCollection = (): number => {
        if (!canAddCollection()) {
            return 0;
        }

        feed.push(collections[collectionIndex]);
        collectionIndex++;

        return weights.collection;
    };

    const addCourse = (): number => {
        if (!canAddCourse()) {
            return 0;
        }

        feed.push(courses[courseIndex]);
        courseIndex++;

        return weights.course;
    };

    const priority = getPriority();

    // Добавляем первую подборку в самое начало ленты (если есть)
    if (canAddCollection()) {
        addCollection();
    }

    while (hasPromptsLeft()) {
        const matrix = getMatrix(columns, priority, canAddCollection());
        const rowsNumber = Object.keys(matrix);

        for (let i = 0; i < rowsNumber.length; i++) {
            const row = matrix[i];
            let rowCurrentWeight = 0;

            if (row.prompts && row.priority === Entity.Prompt) {
                rowCurrentWeight += addPrompts(row.prompts);
            }

            if (
                (hasPromptsLeft() && row.challenge) ||
                (row.challenge && (rowCurrentWeight === 0 || rowCurrentWeight === row.weight - weights.challenge))
            ) {
                rowCurrentWeight += addChallenge();
            }

            // Добавляем подборки или курсы
            if ((hasPromptsLeft() && row.collections) || (row.collections && rowCurrentWeight === 0)) {
                rowCurrentWeight += addCollection();
            } else if ((hasPromptsLeft() && row.courses) || (row.courses && rowCurrentWeight === 0)) {
                rowCurrentWeight += addCourse();
            }

            if (rowCurrentWeight < row.weight) {
                addPrompts(row.weight - rowCurrentWeight);

                if (!hasPromptsLeft()) {
                    break;
                }
            }
        }
    }

    return feed;
};

const getFeedData = (feedData: FeedData, columns: number) => {
    const { collections, prompts, challenges, courses } = feedData;

    const isOneOfEntities = [collections, prompts, challenges, courses].filter(arr => arr.length).length === 1;

    // если существвуют только один тип сущности, то возвращаем его, иначе возвращаем упорядоченный список
    if (isOneOfEntities) {
        return [...collections, ...prompts, ...challenges, ...courses];
    }

    return getOrderedFeed(feedData, columns);
};

export const useFeed = (feedData: FeedData, columns: number) => {
    const feed = getFeedData(feedData, columns);

    return feed;
};
